import { CustomerQueryKeys } from "../Customer/keys";

export const CustomerIntegrationQueryKeys = {
  all: (customerId: string) => [
    ...CustomerQueryKeys.single(customerId),
    "integrations",
  ],
};
